import React, {
  FunctionComponent, MouseEvent, useEffect, useRef, useState
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import HeaderComponent from '../core/components/header/HeaderComponent';
import { AppStateTypes } from '../store/appStateTypes';
import ButtonComponent, { ButtonSizeEnum } from '../core/components/button/ButtonComponent';
import { logoutTypeAction } from '../modules/auth/state/actions';
import { removeCookie } from '../helpers/cookie';
import { COOKIE_NAME_AUTH_TOKEN } from '../constants/cookieNamesConstants';
import { SidebarComponent } from '../core/components/sidebar/SidebarComponent';
import { useModal } from '../hooks/useModal';
import { MODAL_NAME_AUTH } from '../constants/modalNamesConstants';
import { REGISTER_STATE_TYPE } from '../modules/auth/authTypes';
import AuthModalContainer from '../modules/auth/AuthModalContainer';
import { StatsContainer } from '../modules/stats/StatsContainer';
import { useStatsSocket } from '../hooks/useStatsSocket';
import { fetchCurrentSubscription } from '../modules/subscription/state/controller';
import { clearSubscriptionAction } from '../modules/subscription/state/actions';
import { AppDispatch } from '../store/configureStore';

export const withHeader = (Component: FunctionComponent) => () => {
  useStatsSocket();

  const dispatch = useDispatch<AppDispatch>();
  
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);

  const toggleSidebar = () => setIsOpenSidebar((prevState) => !prevState);

  const { user, token } = useSelector((state: AppStateTypes) => state.auth) || {};
  const { currentSubscription, hasSubscription, isInitialized } = useSelector((state: AppStateTypes) => state.subscription);

  // Функция для проверки фич подписки
  const hasFeature = (feature: string): boolean => {
    if (!hasSubscription || !currentSubscription?.plan) {
      return false;
    }
    return currentSubscription.plan.features.includes(feature);
  };

  // Инициализация подписки при наличии токена
  useEffect(() => {
    if (token && !isInitialized) {
      dispatch(fetchCurrentSubscription(token));
    } else if (!token && isInitialized) {
      dispatch(clearSubscriptionAction());
    }
  }, [token, isInitialized, dispatch]);

  const logout = () => {
    dispatch(logoutTypeAction());
    removeCookie(COOKIE_NAME_AUTH_TOKEN);
  };

  const { t } = useTranslation();
  const { isOpenModal: isOpenAuthModal, onOpenModal } = useModal(MODAL_NAME_AUTH);

  const onOpenRegisterModal = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    onOpenModal({ selectedAuthStateType: REGISTER_STATE_TYPE });
  };

  const onOpenAuthModal = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    onOpenModal();
  };

  const refAd = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (refAd && !hasFeature('no_ads')) {
      // @ts-ignore
      window.yaContextCb.push(() => {
        // @ts-ignore
        Ya.Context.AdvManager.render({
          blockId: 'R-A-3642064-6',
          type: 'floorAd',
          platform: 'touch'
        });
      });
    }
  }, [refAd, hasFeature]);

  return (
      <>
        <HeaderComponent
            toggleSidebar={toggleSidebar}
            user={user}
        />
        <Component />
        {isOpenSidebar && (
            <SidebarComponent
                toggleSidebar={toggleSidebar}
                StatsContent={<StatsContainer />}
                AuthContent={user ? (
                    <>
                      <div className="truncate">{user.email}</div>
                      <ButtonComponent text={t('auth.logout')} onClick={logout} className="ml-8" size={ButtonSizeEnum.SM} />
                    </>
                ) : (
                    <>
                      <a href="#" onClick={onOpenRegisterModal} className="text-primary2 mr-8">{t('auth.register')}</a>
                      <a href="#" onClick={onOpenAuthModal} className="text-primary2">{t('auth.login')}</a>
                    </>
                )}
            />
        )}
        {!hasFeature('no_ads') && <div className='mb-15 mobile:hidden' ref={refAd} id="yandex_rtb_R-A-3642064-6" />}
        {isOpenAuthModal && <AuthModalContainer />}
      </>
  );
};
